import Actions from '.';
import { get, post, patch,put, deleteCall } from '../../../utils/api';
import { API_ERROR_MESSAGE } from '../../../constants';

const getSlots = () => (async dispatch => {
    dispatch(Actions.updateProperty('loading', true));
    try {
        const data = await get(`delivery/slot/list`);
        if (data.statusCode === 200) {
            dispatch(Actions.updateProperties({
                loading: false,
                error: '',
                success: true,
                list: (data.response || {}).slots || [],
            }));
        } else {
            dispatch(Actions.updateProperties({
                loading: false,
                error: data.message || API_ERROR_MESSAGE,
                data: [],
            }));
        }
    } catch (e) {
        dispatch(Actions.updateProperties({
            loading: false,
            error: e.message || API_ERROR_MESSAGE,
            data: [],
        }));
    }
});

const getPreference = () => (async dispatch => {
    dispatch(Actions.updateProperty('loadingPreference', true));
    try {
        const data = await get(`organisation/preference`);
        if (data.statusCode === 200) {
            dispatch(Actions.updateProperties({
                loadingPreference: false,
                error: '',
                preferences: data.response.preferences
            }));
        } else {
            dispatch(Actions.updateProperties({
                loadingPreference: false,
                error: data.message || API_ERROR_MESSAGE,
            }));
        }
    } catch (e) {
        dispatch(Actions.updateProperties({
            loadingPreference: false,
            error: e.message || API_ERROR_MESSAGE,
        }));
    }
});


const getTonnageCharge = () => (async dispatch => {
    dispatch(Actions.updateProperty('loadingTonnage', true));
    try {
        const data = await get(`delivery/tonnage-charge/list`);
        if (data.statusCode === 200) {
            
            dispatch(Actions.updateProperties({
                loadingTonnage: false,
                error: '',
                tonnage_charges: data.response.tonnageCharges
            }));
        } else {
            dispatch(Actions.updateProperties({
                loadingTonnage: false,
                error: data.message || API_ERROR_MESSAGE,
            }));
        }
    } catch (e) {
        dispatch(Actions.updateProperties({
            loadingTonnage: false,
            error: e.message || API_ERROR_MESSAGE,
        }));
    }
});

const updateDeliveryPreference = (key, value) => ( async (dispatch, getState) => {
    const { preferences } = getState().delivery;
    dispatch(Actions.updateProperty('loadingPreference', true));
    try {
        const body = preferences.map(p => ({ preferenceName : p.preferenceName, preference: p.preference }))
        const data = await post(`organisation/preference`, { preferences: body });
        if (data.statusCode === 201) {
            dispatch(Actions.updateProperties({
                loadingPreference: false,
                error: '',
            }));
        } else {
            dispatch(Actions.updateProperties({
                loadingPreference: false,
                error: data.message || API_ERROR_MESSAGE,
            }));
        }
    } catch (e) {
        dispatch(Actions.updateProperties({
            loadingPreference: false,
            error: e.message || API_ERROR_MESSAGE,
        }));
    }
});

const updateTonnageCharge = (key, value) => ( async (dispatch, getState) => {
    const { tonnage_charges } = getState().delivery;
    dispatch(Actions.updateProperty('loadingTonnage', true));
    try {
        const body = tonnage_charges.map(p => ({ chargePerKilometer : p.chargePerKilometer, maximumTonnage: p.maximumTonnage,minimumTonnage: p.minimumTonnage }))
        const data = await put(`delivery/tonnage-charge`,body);
        if (data.statusCode === 201) {
            dispatch(Actions.updateProperties({
                loadingTonnage: false,
                error: '',
            }));
        } else {
            dispatch(Actions.updateProperties({
                loadingTonnage: false,
                error: data.message || API_ERROR_MESSAGE,
            }));
        }
    } catch (e) {
        dispatch(Actions.updateProperties({
            loadingTonnage: false,
            error: e.message || API_ERROR_MESSAGE,
        }));
    }
});



const addSlot = body => (async dispatch => {
    dispatch(Actions.updateProperty('loading', true));
    try {
        const data = await post(`delivery/slot`, body);
        if (data.statusCode === 201) {
            dispatch(Actions.updateProperties({
                loading: false,
                error: '',
                showSlotModal: false,
            }));
            dispatch(getSlots());
        } else {
            dispatch(Actions.updateProperties({
                loading: false,
                error: data.message || API_ERROR_MESSAGE,
            }));
        }
    } catch (e) {
        dispatch(Actions.updateProperties({
            loading: false,
            error: e.message || API_ERROR_MESSAGE,
        }));
    }

})

const updateSlot = (id, body) => (async dispatch => {
    dispatch(Actions.updateProperty('loading', true));
    try {
        if(body.nonTileProducts.chargeBy ==1)
        delete body.nonTileProducts.percentageToCharge
        else
        delete body.nonTileProducts.amountToCharge
        const data = await patch(`delivery/slot/${id}`, body);
        if (data.statusCode === 200) {
            dispatch(Actions.updateProperties({
                loading: false,
                error: '',
                showSlotModal: false,
            }));
            dispatch(getSlots());
        } else {
            dispatch(Actions.updateProperties({
                loading: false,
                error: data.message || API_ERROR_MESSAGE,
            }));
        }
    } catch (e) {
        dispatch(Actions.updateProperties({
            loading: false,
            error: e.message || API_ERROR_MESSAGE,
        }));
    }
})

const deleteSlot = id => (async dispatch => {
    dispatch(Actions.updateProperty('loading', true));
    try {
        const data = await deleteCall(`delivery/slot/${id}`);
        if (data.statusCode === 200) {
            dispatch(Actions.updateProperties({
                loading: false,
                error: '',
            }));
            dispatch(getSlots());
        } else {
            dispatch(Actions.updateProperties({
                loading: false,
                error: data.message || API_ERROR_MESSAGE,
            }));
        }
    } catch (e) {
        dispatch(Actions.updateProperties({
            loading: false,
            error: e.message || API_ERROR_MESSAGE,
        }));
    }
})

export default {
    getSlots,
    getPreference,
    getTonnageCharge,
    updateDeliveryPreference,
    updateTonnageCharge,
    addSlot,
    updateSlot,
    deleteSlot,
}